import { Box, Typography } from '@mui/material';

const placeholderPattern = /({{[A-Za-z0-9_:-]+}})/g;

function renderHighlightedText( text, values ) {
	const content = text || '';
	const parts = content.split( placeholderPattern );
	const hasValues = !!values;

	return parts.map(( part, index ) => {
		const match = part.match( /^{{([A-Za-z0-9_:-]+)}}$/ );
		if ( !match ) {
			return part;
		}

		const key = match[1];
		const hasValue = hasValues && values[key] !== undefined && values[key] !== null;
		const display = hasValue ? String( values[key] ) : part;

		return (
			<Box
				key={`${key}-${index}`}
				component="mark"
				title={key}
				sx={{
					backgroundColor: hasValue ? 'success.light' : 'warning.light',
					color: hasValue ? 'success.contrastText' : 'warning.contrastText',
					borderRadius: 0.5,
					px: 0.5,
					whiteSpace: 'pre-wrap'
				}}
			>
				{display}
			</Box>
		);
	});
}

const PromptTextBlock = ({
	label,
	text,
	values,
	fallback = '',
	minHeight,
	maxHeight = 560,
	sx
}) => (
	<Box sx={sx}>
		{label && <Typography variant="caption" color="text.secondary">{label}</Typography>}
		<Box
			component="pre"
			sx={{
				mt: label ? 0.5 : 0,
				p: 2,
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 1,
				backgroundColor: 'background.default',
				color: 'text.primary',
				whiteSpace: 'pre-wrap',
				fontFamily: 'monospace',
				fontSize: '0.875rem',
				lineHeight: 1.5,
				minHeight,
				maxHeight,
				overflow: 'auto'
			}}
		>
			{renderHighlightedText( text || fallback, values )}
		</Box>
	</Box>
);

export default PromptTextBlock;
